function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "send_svg__a",
  d: "M23.364 5.364a.9.9 0 111.272 1.272l-9.9 9.9a.9.9 0 11-1.272-1.272l9.9-9.9zM8.44 12.4l6.026 2.678a.9.9 0 01.456.456L17.6 21.56l4.933-14.093L8.44 12.4zm4.978 4.182l-7.784-3.46c-.744-.33-.7-1.402.069-1.671l18-6.3a.9.9 0 011.146 1.146l-6.3 18c-.269.77-1.34.813-1.671.069l-3.46-7.784z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  transform: "rotate(45 15.121 5.05)",
  xlinkHref: "#send_svg__a"
});

var SvgSend = function SvgSend(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/send.d6e77620.svg";
export { SvgSend as ReactComponent };